import { Aurelia, PLATFORM } from 'aurelia-framework'
import environment from './environment';
import {i18Config} from './i18n-plugin-config';

//Configure Bluebird Promises.
//Note: You may want to use environment-specific configuration.
(<any>Promise).config({
    warnings: {
        wForgottenReturn: false
    }
});

export function configure(aurelia: Aurelia) {

    //ensure that we have a console.log function
    window["con" + "sole"] = window.console || { log: function () { } };

    aurelia.use
        .standardConfiguration()
        .feature('resources')
        .plugin('aurelia-validation')
        .plugin('aurelia-cookie')
        // .plugin('aurelia-i18n', i18Config)
        .plugin('aurelia-dialog', config => {
            config.useDefaults();
            //config.settings.lock = true;
            //config.settings.centerHorizontalOnly = false;
            config.settings.startingZIndex = 5000;
            //config.settings.enableEscClose = true;
        })
        .plugin('aurelia-animator-css')


    if (environment.debug) {
        aurelia.use.developmentLogging();
    }

    if (environment.testing) {
        aurelia.use.plugin('aurelia-testing');
    }

    aurelia.use.plugin('aurelia-google-analytics', config => {
        config.init('G-LDRW9WSX16');
        config.attach({
            logging: {
                // Set to `true` to have some log messages appear in the browser console.
                enabled: true
            },
            pageTracking: {
                // Set to `false` to disable in non-production environments.
                enabled: true,
                // Optional. By default it gets the title from payload.instruction.config.title.
                getTitle: (payload) => {
                    // For example, if you want to retrieve the tile from the document instead override with the following.
                    return payload.instruction.config.title || document.title;
                },
                // Optional. By default it gets the URL fragment from payload.instruction.fragment.
                //getUrl: (payload) => {
                //    // For example, if you want to get full URL each time override with the following.
                //    return window.location.href;
                //}
            },
            clickTracking: {
                // Set to `false` to disable in non-production environments.
                enabled: true,
                // Optional. By default it tracks clicks on anchors and buttons.
                //filter: (element) => {
                //    // For example, if you want to also track clicks on span elements override with the following.
                //    return element instanceof HTMLElement &&
                //        (element.nodeName.toLowerCase() === 'a' ||
                //            element.nodeName.toLowerCase() === 'button' ||
                //            element.nodeName.toLowerCase() === 'span');
                //}
            },
            exceptionTracking: {
                // Set to `false` to disable in non-production environments.
                enabled: true
            }
        });
    });

    aurelia.start().then(() => {
        aurelia.setRoot("public/app");
    });
}
